module.exports = __webpack_public_path__ + "img/9788952236029.d414b2f0.jpg";